export const normalizarCodigo = (codigo) => {
  return String(codigo || "").replace(/[-\s]/g, "");
};

export const getItemDomId = (item) => {
  return item?.valcar
    ? `item-${item.valcar}`
    : `item-${item?.sku}-${item?.nropar}`;
};

/**
 * Parsea el campo difjsn que devuelve la función de completar la auditoría SMA.
 *
 * Viene como texto con el JSON adentro, y según cómo arme el string la base a
 * veces lo deja escapado dos veces. Por eso se intenta deserializar hasta que
 * aparezca el array.
 *
 * @param {string|Array|null|undefined} difjsn
 * @returns {Array<Object>} lista de diferencias, vacía si no hay o no se puede leer
 */
export const parseDiferenciasSMA = (difjsn) => {
  if (difjsn == null) return [];

  // Si ya viene como array no hay nada que deserializar.
  if (Array.isArray(difjsn)) return difjsn;

  let actual = difjsn;

  // hasta 3 intentos, por si viniera doble o triple escapado
  for (let i = 0; i < 3; i++) {
    if (typeof actual !== "string") break;

    const recortado = actual.trim();
    if (!recortado) return [];

    try {
      actual = JSON.parse(recortado);
    } catch {
      return [];
    }
  }

  return Array.isArray(actual) ? actual : [];
};

/**
 * Normaliza una fila de difjsn: la base manda los textos con padding de
 * espacios y las cantidades con decimales.
 */
export const normalizarDiferenciaSMA = (fila) => {
  // Si la base manda algo no numérico, Number() devuelve NaN y en pantalla
  // aparecería literal "NaN". Se cae a 0.
  const numero = (valor) => {
    const n = Number(valor);
    return Number.isFinite(n) ? n : 0;
  };

  return {
    clave: String(fila?.clave ?? "").trim(),
    nivel: String(fila?.nivel ?? "").trim(),
    codigo: String(fila?.codigo ?? "").trim(),
    idartl: String(fila?.idartl ?? "").trim(),
    idartp: fila?.idartp ?? null,
    nombre: String(fila?.nombre ?? "").trim(),
    diferencia: numero(fila?.diferencia),
    cantidad_auditada: numero(fila?.cantidad_auditada),
    cantidad_esperada: numero(fila?.cantidad_esperada),
  };
};
